import "./insured-summary.scss";

import { useTranslation } from "react-i18next";
import { FormikInsured, Gender, YesNoAnswersNew } from "src/types";

export const InsuredSummary = ({
  otherInsured,
  index,
}: {
  otherInsured: FormikInsured;
  index: number;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="other-insured-title-tag mb-4">
        {t("data_entry_step_4.other_insured_title", { number: index + 1 })}
      </div>

      <div className="d-block d-md-flex mb-3">
        {otherInsured.insuredName && (
          <div className="col-12 col-md-6 mb-3 mb-md-0">
            <div className="font-12-light c-7f7f7f">
              {t("data_entry_step_4.insured_name")}
            </div>
            <div className="font-16">{otherInsured.insuredName}</div>
          </div>
        )}
        {otherInsured.insuredSurname && (
          <div className="col-5">
            <div className="font-12-light c-7f7f7f">
              {t("data_entry_step_4.insured_surname")}
            </div>
            <div className="font-16">{otherInsured.insuredSurname}</div>
          </div>
        )}
      </div>

      {otherInsured.insuredFcQuestion === YesNoAnswersNew.YES && (
        <div className="d-block d-md-flex mb-3">
          {otherInsured.insuredFc && (
            <div className="col-12 col-md-6 mb-4 mb-md-0">
              <div className="font-12-light c-7f7f7f">
                {t("data_entry_step_4.insured_fc")}
              </div>
              <div className="font-16">
                {otherInsured.insuredFc?.toUpperCase()}
              </div>
            </div>
          )}
        </div>
      )}

      {otherInsured.insuredFcQuestion === YesNoAnswersNew.NO && (
        <div>
          <div className="d-block d-md-flex mb-3">
            {otherInsured.insuredBirth && (
              <div className="col-12 col-md-6 mb-4 mb-md-0">
                <div className="font-12-light c-7f7f7f">
                  {t("data_entry_step_4.insured_birth")}
                </div>
                <div className="font-16">{otherInsured.insuredBirth}</div>
              </div>
            )}
            {otherInsured.insuredBirthNation && (
              <div className="col-5">
                <div className="font-12-light c-7f7f7f">
                  {t("data_entry_step_4.insured_birth_nation")}
                </div>
                <div className="font-16">{otherInsured.insuredBirthNation}</div>
              </div>
            )}
          </div>
          <div className="d-block d-md-flex mb-3">
            {otherInsured.insuredBirthPlace && (
              <div className="col-12 col-md-6 mb-4 mb-md-0">
                <div className="font-12-light c-7f7f7f">
                  {t("data_entry_step_4.insured_birth_place")}
                </div>
                <div className="font-16">{otherInsured.insuredBirthPlace}</div>
              </div>
            )}

            {otherInsured.insuredGender && (
              <div className="col-12 col-md-6 mb-4 mb-md-0">
                <div className="font-12-light c-7f7f7f">
                  {t("data_entry_step_4.insured_gender")}
                </div>
                <div className="font-16">
                  {otherInsured.insuredGender === Gender.M
                    ? t("data_entry_step_4.insured_gender_male")
                    : otherInsured.insuredGender === Gender.F
                    ? t("data_entry_step_4.insured_gender_female")
                    : ""}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
